<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 14px;
}

.login {
    background-image: url("../static/forest.jpg");
    background-color: white;
    background-size: 100vw 100vh;
  }

option {
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?7c8c90aa